import { FC } from "react";
import classNames from "classnames";

import { Card, Till } from "..";
import { UIStatus } from "../../../types/GlobalTypes";

type Props = {
  icon?: string;
  title: string;
  value: string;
  disabled?: boolean;
  className?: string;
  onClick: (args: any) => void;
  uiStatus?: UIStatus;
  error?: boolean;
  dataTest?: string;
};

export const SelectionCard: FC<Props> = ({
  icon,
  title,
  value,
  disabled,
  className = "",
  onClick,
  uiStatus,
  error,
  dataTest,
}) => {
  // TODO: Look for a way to make the size card param flexible
  return (
    <Card
      className={classNames("flex flex-row gap-x-6 items-center", className)}
      onClick={onClick}
      size={Card.size.XXL}
      disabled={disabled}
      dataTest={dataTest}
      uiStatus={uiStatus}
      error={error}
    >
      {icon && (
        <Till icon={icon} className="bg-white" dataTest={`${dataTest}-icon`} />
      )}

      <div className="flex flex-col gap-y-1">
        <div
          className="uppercase theme-caption"
          data-test={`${dataTest}-title`}
        >
          {title}
        </div>

        <div
          className="theme-text text-wrap break-all"
          data-test={`${dataTest}-value`}
        >
          {value}
        </div>
      </div>
    </Card>
  );
};
